import React from 'react';
import PropTypes from 'prop-types';

const Label = ({ label }) => (
	<>
		<span className="onboarding-box__element" />
		<span className="onboarding-box__text">{label}</span>
	</>
);

Label.propTypes = {
	label: PropTypes.string.isRequired,
};

export default Label;
